import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { isMobile } from "react-device-detect";

import routes from "../routes/routes";

// react components
import Button from "../components/Button";
import PageWrap from "../components/PageWrap";
import SkeletonBox from "../components/SkeletonBox";

const Paragraph = styled.p`
  max-width: 220px;
  margin: 0 auto;
`;

const Heading = styled.h2`
  font-weight: bold;
  font-size: 1.25em;
  margin: 0 0 0.9em;
  color: ${(props) => props.theme.color.darkGray};
`;

const IdIcon = styled.img`
  width: 114px;
  display: inline-block;
  margin-right: 0.4em;
  margin-bottom: 0.95em;
`;

const ExclamationIcon = styled.img`
  width: 78px;
  height: 78px;
  margin-bottom: 1em;
`;

const StyledLink = styled.a`
  color: ${(props) => props.theme.color.midBlue};
`;

export default function Welcome({ uploadedPicture }) {
  return (
    <PageWrap>
      <div>
        {isMobile && !uploadedPicture ? (
          <IdIcon src="/static/images/siebert-ID.svg"></IdIcon>
        ) : (
          <ExclamationIcon src="/static/images/iconAlert.svg" alt="" />
        )}
        <SkeletonBox>
          {isMobile && !uploadedPicture ? (
            <Heading>ID Verification</Heading>
          ) : (
            <Heading>Device Not Compatible</Heading>
          )}
        </SkeletonBox>
        <SkeletonBox>
          <Paragraph>
            {isMobile && !uploadedPicture ? (
              "Please help us verify your identity by securely uploading your ID."
            ) : (
              <React.Fragment>
                <br />
                Please try again using a different mobile device or contact
                support by calling <br />
                <StyledLink href="tel:18667477432">
                  1-866-747-SIEB (7432)
                </StyledLink>
                <br /> or email{" "}
                <StyledLink href="mailto:service@siebert.com">
                  service@siebert.com
                </StyledLink>{" "}
                for assistance.
              </React.Fragment>
            )}
          </Paragraph>
        </SkeletonBox>
      </div>
      {isMobile && !uploadedPicture ? (
        <Button as={Link} to={`${routes.chooseDocument}`}>
          Verify My Identity
        </Button>
      ) : (
        <span> </span>
      )}
    </PageWrap>
  );
}
